var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('ButtonBackList',{attrs:{"toUrl":_vm.toUrl,"isReadOnly":_vm.form.basicSetting.isReadOnly}}),_c('ButtonCopy',{on:{"click":_vm.onCopyClicked}})]},proxy:true},{key:"right",fn:function(){return [_c('ButtonPrev'),_c('ButtonNext',{attrs:{"form":_vm.form}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }